import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { POLITICAS } from "../lib/content";

export const Policies = () => {
  const [open, setOpen] = useState("capital");

  return (
    <section id="politicas" className="bg-[#F3F4F6] py-24 md:py-32" data-testid="policies-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#0A2463]" />
              <span className="font-headings text-xs tracking-[0.3em] uppercase text-[#0A2463]">
                10 políticas principales
              </span>
            </div>
            <h2 className="font-headings font-bold uppercase tracking-tight text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Lo que <span className="fy-underline">vamos a hacer</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-lg text-[#4B5563] leading-relaxed">
              No son promesas: son piezas de un sistema integrado. Cada política se sostiene en las demás.
              Hace clic en cada una para ver el detalle.
            </p>
          </div>
        </div>

        {/* Accordion list */}
        <div className="border-t border-gray-300" data-testid="policies-list">
          {POLITICAS.map((p, i) => {
            const isOpen = open === p.id;
            return (
              <div key={p.id} className="border-b border-gray-300" data-testid={`policy-item-${p.id}`}>
                <button
                  onClick={() => setOpen(isOpen ? null : p.id)}
                  className="w-full flex items-center gap-4 sm:gap-8 py-7 text-left group"
                  data-testid={`policy-toggle-${p.id}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-headings text-xl sm:text-2xl font-bold text-[#F5B400] tabular-nums w-10 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1 grid sm:grid-cols-2 gap-2 sm:gap-6 items-center">
                    <h3 className="font-headings text-xl sm:text-2xl font-semibold uppercase tracking-tight text-[#0A192F] group-hover:text-[#0A2463] transition-colors">
                      {p.titulo}
                    </h3>
                    <p className="text-sm sm:text-base text-[#4B5563]">{p.resumen}</p>
                  </div>
                  <span className="hidden md:block font-headings text-sm uppercase tracking-[0.2em] text-[#0A2463] bg-white border border-gray-300 px-3 py-1.5 shrink-0">
                    {p.metrica}
                  </span>
                  <span className="shrink-0 h-9 w-9 border border-[#0A192F] flex items-center justify-center text-[#0A192F] group-hover:bg-[#0A192F] group-hover:text-white transition-colors">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <div className="pb-8 pl-0 sm:pl-[3.5rem] pr-2 max-w-3xl">
                        <p className="text-base sm:text-lg text-[#0A192F] leading-relaxed">
                          {p.detalle}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Policies;
